// Bảng lịch sử phiên bản của node đang chọn. Mỗi dòng là một version đã đóng/đang mở
// (append-only, BR-CFG-01); dòng khớp currentVersion được highlight + aria-current.
// validTo null hiển thị "∞".
// scroll.x="max-content": tổng cột cố định (566px) vượt cột chi tiết ~506px ở 1280 khiến
// cột "Tên" auto-width bị sập về 0px (AC-13 vi phạm ở 1280). Cho bảng tự nhiên theo
// max-content và để vùng bảng cuộn ngang — mọi cột đọc được ở cả 1280 lẫn 1440.

import { Empty, Table, type TableProps } from "antd";
import { formatDateVn } from "../../../lib/dateFormat";
import type { AdminVersion } from "../adminTypes";
import { StatusTag } from "./StatusTag";

export function VersionHistoryTable({
  versions,
  currentVersion,
  classificationLabel,
}: {
  readonly versions: readonly AdminVersion[];
  readonly currentVersion: number;
  readonly classificationLabel: string;
}) {
  const columns: TableProps<AdminVersion>["columns"] = [
    {
      title: "Phiên bản",
      dataIndex: "version",
      width: 96,
      render: (version: number) => `v${version}`,
    },
    {
      title: "Hiệu lực",
      key: "period",
      width: 210,
      render: (_value, row) => (
        <span className="admin-history-period">
          {formatDateVn(row.validFrom)} → {formatDateVn(row.validTo ?? "∞")}
        </span>
      ),
    },
    { title: "Tên", dataIndex: "name", ellipsis: true },
    { title: classificationLabel, dataIndex: "classification", width: 140 },
    { title: "Trạng thái", dataIndex: "status", width: 120, render: (status: string) => <StatusTag status={status} /> },
  ];

  return (
    <Table<AdminVersion>
      size="small"
      rowKey="version"
      columns={columns}
      dataSource={[...versions].sort((a, b) => a.validFrom.localeCompare(b.validFrom))}
      pagination={false}
      scroll={{ x: "max-content" }}
      locale={{
        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có lịch sử phiên bản" />,
      }}
      onRow={(row) => ({
        className: row.version === currentVersion ? "admin-row-current" : undefined,
        "aria-current": row.version === currentVersion ? "true" : undefined,
      })}
    />
  );
}
